import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PHONE_COUNTRIES, flagUrl } from "@/lib/phoneCountries";

const Flag = ({ code }) => (
  <img src={flagUrl(code)} alt="" className="w-5 h-[14px] rounded-[2px] object-cover shrink-0" />
);

export function PhoneInput({ country, onCountry, value, onChange }) {
  const c = PHONE_COUNTRIES.find((x) => x.code === country) || PHONE_COUNTRIES[0];
  return (
    <div className="flex gap-2">
      <Select value={c.code} onValueChange={onCountry}>
        <SelectTrigger className="w-[112px] shrink-0" data-testid="phone-country-select">
          <SelectValue>
            <span className="flex items-center gap-1.5"><Flag code={c.code} />+{c.dial}</span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-72">
          {PHONE_COUNTRIES.map((x) => (
            <SelectItem key={x.code} value={x.code} data-testid={`phone-country-${x.code}`}>
              <span className="flex items-center gap-2"><Flag code={x.code} />{x.name} <span className="text-muted-foreground">+{x.dial}</span></span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        type="tel" inputMode="tel" autoComplete="tel-national"
        placeholder={c.code === "FR" ? "06 12 34 56 78" : "Numéro de portable"}
        value={value} onChange={(e) => onChange(e.target.value)}
        data-testid="phone-number-input"
      />
    </div>
  );
}
